module.exports = __webpack_public_path__ + "img/logo-app.ddf56d13.svg";